export const palette = {
  alternate: {
    main: '#F9F6FF',
    light: '#f8f1e5',
    dark: '#E5EAF4',
  },
  cardShadow: 'rgba(23, 70, 161, .11)',
  type: 'light',
  primary: {
    main: '#FF9C4A', // Material-UI needs solid color
    gradient: 'linear-gradient(94deg, #FF9C4A -5.39%, #D2E5EC 102.3%)', // Your gradient here
    light: '#f8f1e5',
  },
  secondary: {
    main: '#DCF3FF',
    contrastText: '#FFFFFF',
    light: '#D9EDF7',
  },
  text: {
    primary: '#22211F',
    secondary: '#4A5462',
    alternate: '#23B0E7',
    disabled: '#CCC',
    highlight: '#FFF',
    success: '#1CA179',
    border: '#E5EAF4',
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  background: {
    main: '#FFFFFF',
    paper: '#FFF',
    default: '#FFF',
    header: 'linear-gradient(121deg, #FFD9BB -7.47%, #FFF 38.39%, #F7FCFF 65.98%, #DCF3FF 122.6%)',
    footer: '#181000',
    level2: '#f7f8fb',
    level1: '#FFF',
    tableHead: '#FF9B4B',
    tableSubhead: '#DCF3FF',
    tableBorder: '#7D808880',
    tableAlternate: '#FFFFFF',
    alternate: '#E5EAF4',
    success: '#DBEFDC',
    error: '#FFEAEA',
    primary: '#E9EDEF80',
    secondary: '#F8D859',
    light: '#F8FBFE',
    secondaryLight: 'rgba(238, 246, 250, 0.6)',
    primaryLight: '#D9EDF7',
    ribbon: '#bbe6fb',
    primary: '#F6F6F6'
  },
  surface: {
    grey: '#F6F6F6',
    howItWorks: 'linear-gradient(100deg, #DFF4FF -80.24%, #FFF 83.59%)',
    pricing: 'linear-gradient(121deg, #FFD9BB -7.47%, #FFF 38.39%, #F7FCFF 65.98%, #DCF3FF 122.6%)',
    learnMore: '#F4F4F4',
    header: '#EBF6FF',
    footer: 'linear-gradient(100deg, #DFF4FF -80.24%, #FFF 83.59%)'
  },
  verticalBar: {
    used: '#687462',
    unused: '#F6F6F6',
    unlimited: '#C0C0C0',
  },
};
